import React, { useState, useCallback, useRef, useEffect } from "react";
import logoPlaceholder from "../../../../assets/design-revamp-company/company-intro/logo-placeholder.svg";
import closeBtn from "../../../../assets/design-revamp-company/company-epr/x_btn_epr.svg";
import uploadIcon from "../../../../assets/design-revamp-company/company-intro/download-icon.svg";
import "./index.css";
import {
  getReportLogo,
  deleteReportLogo,
  addReportLogo,
} from "../../../../apis/Report/Report";
import { YearTabContext } from "../../../../components/Skeleton";

export const CompanyIntroCard = ({ name }) => {
  const year = React.useContext(YearTabContext);
  const [logo, setLogo] = useState(null);
  const [fileName, setFileName] = useState("logo.png");
  const [publicId, setPublicId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const cloudinaryRef = useRef();
  const widgetRef = useRef();

  const cloudName = "azilisdjo";
  const uploadPreset = "upload";

  React.useEffect(() => {
    cloudinaryRef.current = window.cloudinary;
    widgetRef.current = cloudinaryRef.current.createUploadWidget(
      {
        cloudName: cloudName,
        uploadPreset: uploadPreset,
        folder: "reportlogo",
      },
      async function (error, result) {
        if (!error && result && result.event === "success") {
          setIsLoading(true);
          try {
            const logoUrl = result.info.secure_url;
            const imagePublicId = result.info.public_id;

            // Update state
            setLogo(logoUrl);
            setFileName(result.info.original_filename);
            setPublicId(imagePublicId);

            // Save to backend
            await addReportLogo({
              logo: logoUrl,
              publicId: imagePublicId,
            });
          } catch (error) {
            console.error("Error saving logo:", error);
            // Optionally reset states if save fails
            setLogo(null);
            setFileName("logo.png");
            setPublicId(null);
          } finally {
            setIsLoading(false);
          }
        }
      }
    );
  }, []);

  const handleUpload = useCallback(() => {
    if (!isLoading) {
      widgetRef.current?.open();
    }
  }, [isLoading]);

  const handleClear = useCallback(async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        await deleteReportLogo({});
        setLogo(null);
        setFileName("logo.png");
        setPublicId(null);
      } catch (error) {
        console.error("Error clearing logo:", error);
      } finally {
        setIsLoading(false);
      }
    }
  }, [isLoading]);

  useEffect(() => {
    const loadInitialLogo = async () => {
      setIsLoading(true);
      try {
        await getReportLogo({ setLogo });
      } catch (error) {
        console.error("Error loading initial logo:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadInitialLogo();
  }, [year]);

  return (
    <div className="company-intro-card-container">
      <h5 style={{ fontWeight: "bold" }}>Company</h5>
      <p>{name}</p>
      <img
        src={logo || logoPlaceholder}
        alt="Company Logo"
        width={70}
        height={70}
        style={{ objectFit: "cover", marginBottom: "20px" }}
      />

      <div style={{ position: "absolute", bottom: "-20px" }}>
        <div className="download-card-container">
          <img
            src={closeBtn}
            alt="Close btn"
            width={13}
            height={13}
            style={{
              position: "absolute",
              top: "-4px",
              left: "-6px",
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.5 : 1,
            }}
            onClick={handleClear}
          />
          <div className="file-name-bg">
            <p style={{ marginBottom: "0", fontSize: "10px" }}>
              {isLoading ? "Processing..." : fileName}
            </p>
          </div>
          <div
            onClick={handleUpload}
            style={{
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.5 : 1,
            }}
          >
            <img src={uploadIcon} alt="Upload Icon" width={18} height={18} />
          </div>
        </div>
      </div>
    </div>
  );
};
